
<div class="register-container">
  <div class="row row-1">
    <div class="col-sm-7 col-1">
      <h2 class="overview-header register-header">Register</h2>
    </div>
    <div class="col-sm-5 col-2">
      <h4 class="register-header click-here float-right"></h4>
    </div>
  </div>

  <div class="card" style="">
    <div class="card-header bp-card-header">
      <!-- Steps form -->
      <div class="card">
        <div class="card-body mb-4">
          <!-- Stepper -->
          <div class="steps-form">
            <div class="steps-row setup-panel">
              <div class="steps-step step-1">
                <a href="#step-9" type="button" class="btn btn-indigo btn-circle">1</a>
                <p class="bp-text">Find Account</p>
              </div>
              <div class="steps-step step-2">
                <a href="#step-10" type="button" class="btn btn-default btn-circle" disabled="disabled">2</a>
                <p class="bp-text">About You</p>
              </div>
              <div class="steps-step step-3">
                <a href="#step-11" type="button" class="btn btn-default btn-circle" disabled="disabled">3</a>
                <p class="bp-text">Set Password</p>
              </div>
            </div>
          </div>

          <form role="form" action="" method="post">

            <!-- First Step -->
            <div class="row setup-content" id="step-9">
              <div class="col-md-12">
              </div>
            </div>

            <!-- Second Step -->
            <div class="row setup-content" id="step-10">
              <div class="col-md-12">
              </div>
            </div>

            <!-- Third Step -->
            <div class="row setup-content" id="step-11">
              <div class="col-md-12">
              </div>
            </div>

          </form>

        </div>
      </div>
      <!-- Steps form -->
    </div>
    <div class="card-body" style="margin-bottom: 3%;">
      <div class="row register-row msg-row">
        <div class="col-sm-12">
          <p class="bp-medium-big-text" style="margin-bottom: 2rem;">To create your profile, you must first find your account.</p>
        </div>
      </div>
      <div class="row register-row">
        <!--<div class="col-sm-12">-->
        <div class="btn-group btn-group-toggle" data-toggle="buttons" style="width: 100%;border-bottom: 1px solid #3F8F8B;">
          <label #registeremail class="btn btn-secondary col-4 active" (click)="usingEmail()">
            <input type="radio" name="options" id="option1" autocomplete="off" checked><i class="fas fa-envelope register-icon"></i>FIND USING EMAIL
          </label>
          <label #registerbill class="btn btn-secondary col-4" (click)="usingBillInfo()">
            <input type="radio" name="options" id="option2" autocomplete="off"><i class="fas fa-envelope-open register-icon"></i>FIND USING BILL INFO
          </label>
          <label #registerpersonalinfo class="btn btn-secondary col-4" (click)="usingPersonalInfo()">
            <input type="radio" name="options" id="option3" autocomplete="off"><i class="fas fa-user register-icon"></i>FIND USING PERSONAL INFO
          </label>
        </div>
        <!--</div>-->
      </div>

      <div *ngIf="showEmail" class="register-email-container" id="registerEmail">
        <div class="row">
          <div class="col-sm-12">
            <div class="row register-row bp-text bp-small-text" style="margin-top: 2.8rem;margin-bottom: 1.6rem;">
              <p>Provide the email address used to establish your account(s). You will receive an email shortly to that inbox to complete registration. Please check your spam folder if you don't receive the email.</p>
              <p>If you don't know the email address, use your billing or personal information to find your account(s).</p>
            </div>
            <div class="alert alert-danger" role="alert" *ngIf="emailNotFound">
              <i class="fas fa-exclamation-triangle"></i>
              <span>
                The email address you entered is not registered with your utility. You will need to contact your utility and provide them with your preferred email address in order to register your account and to gain access to your water portal.
                <a class="btn btn-primary" (click)="viewZipLookUp()">Click here </a> to locate water utilities that serve your area.
              </span>
            </div>
          </div>
        </div>


        <div class="row" *ngIf="showUtilZipLookUp" id="utilListDiv">
          <a id="closeUtilBtn" class="btn btn-primary" (click)="closeUtilList()">Close Utility Lookup</a>
          <div class="col-sm-12">
            <div id="utilList">
              <label>Lookup Utility by Zip Code: </label><input #zip class="form-control" type="text" id="zipLookup" placeholder="Enter Zip Code" />
              <button class="btn btn-primary searchBtn" (click)="update(zip.value)">Search</button>
              <p class="red">{{zipmsg}}</p>
            </div>
          </div>
        </div>

        <div class="row" *ngIf="showUtilities" id="utilListDiv">
          <div class="col-sm-12">
            <div id="utilList">
              <table>
                <tr>
                  <th>Utility</th>
                  <th>Phone Number</th>
                  <th>Phone Ext.</th>
                  <th>Email Address</th>
                  <th>Zip Code</th>
                </tr>

                <tr *ngFor="let util of utilList">
                  <td>{{util.name}}</td>
                  <td>{{util.phone}}</td>
                  <td>{{util.phoneExt}}</td>
                  <td>{{util.email}}</td>
                  <td>{{util.zipCode}}</td>
                </tr>
              </table>
            </div>
          </div>
        </div>

        <div class="row register-row">
          <div class="col-sm-12">
            <form #registrationForm="ngForm">
              <div class="form-group">
                <label for="registerEmailInput" class="bp-text login-label bp-small-text">Email Address</label>
                <input #email="ngModel" [(ngModel)]="customer.email" name="email" required type="email" class="form-control input-register-email" id="registerEmailInput">
                <div [hidden]="email.valid || email.pristine"
                     class="alert alert-danger alert-email">Please enter Email</div>
              </div>
              <div class="form-group" style="margin-bottom: 2rem;">
                <re-captcha class="recaptcha" required name="captcha" [(ngModel)]="captcha" (resolved)="resolvedCaptcha($event)"></re-captcha>
              </div>
              <div class="form-group">
                <button type="submit" [disabled]="!registrationForm.form.valid" class="btn btn-primary bp-text" (click)="onLookupClick()">LOOKUP ACCOUNT</button>
                <span><a class="bp-link-blue" (click)="onCancel()">CANCEL</a></span>
              </div>
            </form>
          </div>
        </div>
      </div>

      <div *ngIf="showBill" class="register-bill-container register" id="registerbill">
        <div class="col-sm-12 col-no-padding">
          <p class="bp-text bp-medium-text">Find your account information on your bill or contact support.</p>
        </div>
        <div class="row register-row bp-text bp-small-text">
          <div class="col-sm-12" style="padding-left: 0 !important;">
            <p class="color: #777;">All fields are required.</p>
          </div>
        </div>

        <div class="row">
          <div class="alert alert-danger col-sm-12" role="alert" *ngIf="billNotFound">
            <i class="fas fa-exclamation-triangle" style="margin-right: 0.4rem;"></i>
            <span>Sorry, we were unable to locate any accounts with the information provided.</span>
          </div>
        </div>

        <div class="row register-row">
          <div class="col-sm-6">
            <form #registrationBillInfoForm="ngForm">
              <div class="form-group bill-info-form-group">
                <label for="registerAccountNumber" class="bp-text login-label bp-small-text">Account Number</label>
                <input #accountNumber="ngModel" [(ngModel)]="customer.accountNumber" name="accountNumber" required type="text" class="form-control input-register-acct-number" id="registerAccountNumber">
                <div [hidden]="accountNumber.valid || accountNumber.pristine" class="alert alert-danger account-number-alert">Please enter Account Number</div>
                <label for="registerWebAccessCode" class="bp-text login-label bp-small-text" style="margin-top: 1.8rem;">Web Access Code</label>
                <input #webAccessCode="ngModel" [(ngModel)]="customer.webAccessCode" name="webAccessCode" required type="text" class="form-control input-register-web-access-code" id="registerWebAccessCode">
                <div [hidden]="webAccessCode.valid || webAccessCode.pristine" class="alert alert-danger alert-web-access-code">Please enter Web Access Code</div>
              </div>
              <div class="form-group">
                <re-captcha class="recaptcha" required name="captcha" [(ngModel)]="captcha" (resolved)="resolvedCaptcha($event)"></re-captcha>
              </div>
              <div class="form-group">
                <button type="submit" [disabled]="!registrationBillInfoForm.form.valid" class="btn btn-primary bp-text" (click)="onLookupClick()">LOOKUP ACCOUNT</button>
                <span><a class="bp-link-blue" (click)="onCancel()">CANCEL</a></span>
              </div>
            </form>
          </div>
          <div class="col-sm-6">
          </div>
        </div>
      </div>
      <div *ngIf="showPersonal" class="register-personal-info-container register">
        <div class="row register-row">
          <div class="col-sm-12 col-no-padding" style="margin-top: 2rem;">
            <p class="bp-text bp-medium-text"><span class="bp-bold-text">Access using Personal Information is for Residential Customers only.</span> The requested information pertains to the person who established the account.</p>
          </div>
        </div>
        <div class="alert alert-danger" role="alert" *ngIf="personalInfoNotFound">
          <i class="fas fa-exclamation-triangle"></i>
          <span>Sorry, we were unable to locate any accounts with the information provided.</span>
        </div>
        <div class="row register-row bp-text bp-small-text">
          <p class="color: #777;">All fields are required.</p>
        </div>
        <div class="row register-row">
          <div class="col-sm-6">
            <form #registrationPersonalInfoForm="ngForm">
              <div class="form-group bill-info-form-group">

                <label for="registerFirstName" class="bp-text login-label bp-small-text">First Name</label>
                <input #firstName="ngModel" [(ngModel)]="customer.firstName" name="firstName" required type="text" class="form-control form-input-6" id="registerFirstName">
                <div [hidden]="firstName.valid || firstName.pristine" class="alert alert-danger register-alert-6">Please enter First Name</div>

                <label for="registerLastName" class="bp-text login-label bp-small-text" style="margin-top: 1.8rem;">Last Name</label>
                <input #lastName="ngModel" [(ngModel)]="customer.lastName" name="lastName" required type="text" class="form-control form-input-6" id="registerlastName">
                <div [hidden]="lastName.valid || lastName.pristine" class="alert alert-danger register-alert-6">Please enter Last Name</div>

                <label for="registerPropertyZip" class="bp-text login-label bp-small-text" style="margin-top: 1.8rem;">Zip Code of Property</label>
                <input #propertyZip="ngModel" [(ngModel)]="customer.zipCode" name="propertyZip" required type="text" class="form-control form-input-6" id="registerpropertyZip">
                <div [hidden]="propertyZip.valid || propertyZip.pristine" class="alert alert-danger register-alert-6">Please enter Property Zip Code</div>
              </div>
              <div class="form-group" style="margin-bottom: 2rem;">
                <re-captcha class="recaptcha" required name="captcha" [(ngModel)]="captcha" (resolved)="resolvedCaptcha($event)"></re-captcha>
              </div>
              <div class="form-group">
                <button type="submit" [disabled]="!registrationPersonalInfoForm.form.valid" class="btn btn-primary bp-text" (click)="onLookupClick()">LOOKUP ACCOUNT</button>
                <span><a class="bp-link-blue" (click)="onCancel()">CANCEL</a></span>
              </div>
            </form>
          </div>
          <div class="col-sm-6">
          </div>
        </div>
      </div>
    </div>
    <footer class="blockquote-footer water-usage-footer"></footer>
  </div>
</div>



// WEBPACK FOOTER //
// ./src/app/register/register.component.html